<template>
  <el-input
    v-model="numberValue"
    type="number"
    :maxlength="maxLength"
    show-word-limit
    :disabled="disabled"
    :placeholder="placeholder"
  />
</template>

<script>
export default {
  props: {
    maxLength: {
      type: Number,
      required: false,
      default: null,
    },
    value: {
      type: [String, Number],
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  computed: {
    numberValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val === "" ? undefined : parseFloat(val));
      },
    },
  },
};
</script>
